export const environment = {
    production: true,
    API_URL: 'https://api.gatherco.com.au/v2/',
    CLIENT_ID: '15072021002',
    CLIENT_SECRET: 'GKBC2021157',
    FRONTEND_CLIENT_ID: '15072021001',
    FRONTEND_CLIENT_SECRET: 'KLURQWCN15',
    GRANT_TYPE: 'password',
    FACEBOOK_APP_ID: '840587173156641',
    GOOGLE_CLIENT_ID: '818998394662-tt1fucr9omf2a8m8l00jdecd2fqe8hhb.apps.googleusercontent.com',
    IMAGE_KIT_ENDPOINT: 'https://ik.imagekit.io/gatherco',
    HOST_URL: "https://www.gatherco.com.au", // URL where this app is hosted,
    GOOGLE_MAP_KEY: 'AIzaSyBmrteJJkGW97DAtSk7mw8Sm8TrtE-ncqU'
};
